import { mutate } from '@/gql/apolloClient';
import { EMIT_EVENT, TRACK } from '@/gql/queries/analytics.gql';

export const track = async (data) =>
  mutate(TRACK, { data }, 'track', undefined);

export const emitSignal = async (data) =>
  mutate(EMIT_EVENT, { data }, 'emit', undefined);
